import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when two-factor authentication popup was opened.
 * @memberOf Playtech.API.events
 * @event TWO_FA_POPUP_OPENED
 * @type {callback}
 * @param {string[]} details details[0] is component.
 * @example Playtech.on('TWO_FA_POPUP_OPENED', ([Component]) => { ... });
 */
export const TWO_FA_POPUP_OPENED = 'TWO_FA_POPUP_OPENED';

export const useOn2FAPopupOpened = (eventTarget: EventTarget): void => {
    const trigger2FAPopupOpenedEvent = useCallback((...component: string[]) => {
        const popupOpened = new CustomEvent(TWO_FA_POPUP_OPENED, { detail: component });

        eventTarget.dispatchEvent(popupOpened);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('2fa-popup-opened', trigger2FAPopupOpenedEvent);

        return () => {
            publicEventsAPIService.off('2fa-popup-opened', trigger2FAPopupOpenedEvent);
        };
    }, [trigger2FAPopupOpenedEvent]);
};
